<template>
  <div :class="{ 'pt-10 pb-25': true }">
    <!--, 'max-cntent-area': page === 'review' -->
    <template v-if="page === 'review'">
      <span
        class="span-h2"
        v-if="comparisonData.block_title && comparisonData.block_title != ''"
        >{{ comparisonData.block_title }}
      </span>
      <div class="online-gambling-container">
        <div
          :class="{
            'online-gambling-green':
              comparisonData.style === 'pros_cons_comparison',
            'online-gambling-blue':
              comparisonData.style === 'general_comparison',
          }"
        >
          <div
            :class="{
              'online-gambling-green-header':
                comparisonData.style === 'pros_cons_comparison',
              'online-gambling-blue-header':
                comparisonData.style === 'general_comparison',
            }"
          >
            <p>
              <i v-if="!comparisonData.disabled_icon">
                <template v-if="comparisonData.left.icon">
                  <img
                    :src="comparisonData.left.icon"
                    width="26"
                    height="26"
                    alt="Tick Big"
                  />
                </template>
                <template v-else>
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.8644 2.43441C17.5097 0.245343 14.0078 0.639093 11.8464 3.07191L10.9999 4.02347L10.1535 3.07191C7.99643 0.639093 4.49018 0.245343 2.13549 2.43441C-0.562943 4.94691 -0.70474 9.45628 1.7101 12.1797L10.0246 21.5453C10.5617 22.15 11.4339 22.15 11.971 21.5453L20.2855 12.1797C22.7046 9.45628 22.5628 4.94691 19.8644 2.43441Z"
                      fill="white"
                    />
                  </svg>
                </template> </i
              >{{ comparisonData.left.heading }}
            </p>
          </div>
          <div class="online-gambling-green-content">
            <div
              :class="{
                'custom-font custm-text': true,
                'tick-div-green':
                  comparisonData.style === 'pros_cons_comparison' &&
                  comparisonData.left.content.indexOf('ul') > 0,
                'tick-div-blue':
                  comparisonData.style === 'general_comparison' &&
                  comparisonData.left.content.indexOf('ul') > 0,
                'num-cls':
                  comparisonData.style === 'general_comparison' &&
                  comparisonData.left.content.indexOf('ol') > 0,
              }"
              :style="{
                '--heading-font': $root.font_family.heading,
                '--paragraph-font': $root.font_family.paragraph,
              }"
              v-html="comparisonData.left.content"
            ></div>
          </div>
        </div>
        <div
          :class="{
            'online-gambling-red':
              comparisonData.style === 'pros_cons_comparison',
            'online-gambling-blue':
              comparisonData.style === 'general_comparison',
          }"
        >
          <div
            :class="{
              'online-gambling-red-header':
                comparisonData.style === 'pros_cons_comparison',
              'online-gambling-blue-header':
                comparisonData.style === 'general_comparison',
            }"
          >
            <p>
              <i v-if="!comparisonData.disabled_icon">
                <template v-if="comparisonData.right.icon">
                  <img
                    :src="comparisonData.right.icon"
                    width="26"
                    height="26"
                    alt="Cross Big"
                  />
                </template>
                <template v-else>
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.3541 1.95916L20.251 1.84197C18.2744 -0.361156 15.1806 -0.581468 12.9635 1.14822L14.4373 5.99509L10.3123 8.99509L12.3748 14.9951L6.18728 8.24509L10.3123 5.24509L9.08338 1.19041C6.86189 -0.581468 3.73807 -0.375218 1.74861 1.84666L1.64549 1.95916C-0.447091 4.29353 -0.537325 8.01072 1.33182 10.4998L10.4455 20.7467C10.7506 21.0888 11.2447 21.0888 11.5498 20.7467L20.6678 10.4951C22.5369 8.01072 22.4467 4.29353 20.3541 1.95916Z"
                      fill="white"
                    />
                  </svg>
                </template> </i
              >{{ comparisonData.right.heading }}
            </p>
          </div>
          <div class="online-gambling-red-content">
            <div
              :class="{
                'custom-font custm-text': true,
                'cross-div':
                  comparisonData.style === 'pros_cons_comparison' &&
                  comparisonData.right.content.indexOf('ul') > 0,
                'tick-div-blue':
                  comparisonData.style === 'general_comparison' &&
                  comparisonData.right.content.indexOf('ul') > 0,
                'num-cls':
                  comparisonData.style === 'general_comparison' &&
                  comparisonData.right.content.indexOf('ol') > 0,
              }"
              :style="{
                '--heading-font': $root.font_family.heading,
                '--paragraph-font': $root.font_family.paragraph,
              }"
              v-html="comparisonData.right.content"
            ></div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="page === 'partner-review-block'">
      <template
        v-if="
          partnerProcons &&
          partnerProcons.length > 0 &&
          (partnerProcons.filter((ele) => ele.is_positive === '1') ||
            partnerProcons.filter((ele) => ele.is_positive === '0'))
        "
      >
        <span
          class="span-h2"
          v-if="comparisonData.block_title && comparisonData.block_title != ''"
          >{{ comparisonData.block_title }}
        </span>
        <div class="online-gambling-container">
          <div
            :class="{
              'online-gambling-green':
                comparisonData.style === 'pros_cons_comparison',
              'online-gambling-blue':
                comparisonData.style === 'general_comparison',
              'wd-50':
                partnerProcons.filter((ele) => ele.is_positive === '0')
                  .length === 0,
            }"
            v-if="
              partnerProcons.filter((ele) => ele.is_positive === '1').length > 0
            "
          >
            <div
              :class="{
                'online-gambling-green-header':
                  comparisonData.style === 'pros_cons_comparison',
                'online-gambling-blue-header':
                  comparisonData.style === 'general_comparison',
              }"
            >
              <p>
                <i v-if="!comparisonData.disabled_icon">
                  <template v-if="comparisonData.left.icon">
                    <img
                      :src="comparisonData.left.icon"
                      width="26"
                      height="26"
                      alt="Tick Big"
                    />
                  </template>
                  <template v-else>
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.8644 2.43441C17.5097 0.245343 14.0078 0.639093 11.8464 3.07191L10.9999 4.02347L10.1535 3.07191C7.99643 0.639093 4.49018 0.245343 2.13549 2.43441C-0.562943 4.94691 -0.70474 9.45628 1.7101 12.1797L10.0246 21.5453C10.5617 22.15 11.4339 22.15 11.971 21.5453L20.2855 12.1797C22.7046 9.45628 22.5628 4.94691 19.8644 2.43441Z"
                        fill="white"
                      />
                    </svg>
                  </template> </i
                >{{ $root.i18n.pros }}
              </p>
            </div>
            <div
              :class="{
                'online-gambling-green-content custm-text': true,
                'tick-div-green':
                  comparisonData.style === 'pros_cons_comparison',
              }"
            >
              <ul>
                <li
                  class="pros-li"
                  v-for="(data, index) in partnerProcons.filter(
                    (ele) => ele.is_positive === '1'
                  )"
                  :key="index"
                >
                  {{ data.description }}
                </li>
              </ul>
            </div>
          </div>
          <div
            :class="{
              'online-gambling-red':
                comparisonData.style === 'pros_cons_comparison',
              'online-gambling-blue':
                comparisonData.style === 'general_comparison',
              'wd-50':
                partnerProcons.filter((ele) => ele.is_positive === '1')
                  .length === 0,
            }"
            v-if="
              partnerProcons.filter((ele) => ele.is_positive === '0').length > 0
            "
          >
            <div
              :class="{
                'online-gambling-red-header':
                  comparisonData.style === 'pros_cons_comparison',
                'online-gambling-blue-header':
                  comparisonData.style === 'general_comparison',
              }"
            >
              <p>
                <i v-if="!comparisonData.disabled_icon">
                  <template v-if="comparisonData.right.icon">
                    <img
                      :src="comparisonData.right.icon"
                      width="26"
                      height="26"
                      alt="Cross Big"
                    />
                  </template>
                  <template v-else>
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.3541 1.95916L20.251 1.84197C18.2744 -0.361156 15.1806 -0.581468 12.9635 1.14822L14.4373 5.99509L10.3123 8.99509L12.3748 14.9951L6.18728 8.24509L10.3123 5.24509L9.08338 1.19041C6.86189 -0.581468 3.73807 -0.375218 1.74861 1.84666L1.64549 1.95916C-0.447091 4.29353 -0.537325 8.01072 1.33182 10.4998L10.4455 20.7467C10.7506 21.0888 11.2447 21.0888 11.5498 20.7467L20.6678 10.4951C22.5369 8.01072 22.4467 4.29353 20.3541 1.95916Z"
                        fill="white"
                      />
                    </svg>
                  </template> </i
                >{{ $root.i18n.cons }}
              </p>
            </div>
            <div
              :class="{
                'online-gambling-red-content custm-text': true,
                'cross-div': comparisonData.style === 'pros_cons_comparison',
              }"
            >
              <ul>
                <li
                  class="cons-li"
                  v-for="(data, index) in partnerProcons.filter(
                    (ele) => ele.is_positive === '0'
                  )"
                  :key="index"
                >
                  {{ data.description }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <span
        class="span-h2"
        v-if="comparisonData.block_title && comparisonData.block_title != ''"
        >{{ comparisonData.block_title }}
      </span>
      <div class="online-gambling-container">
        <div
          :class="{
            'online-gambling-green':
              comparisonData.style === 'pros_cons_comparison',
            'online-gambling-blue':
              comparisonData.style === 'general_comparison',
          }"
        >
          <div
            :class="{
              'online-gambling-green-header':
                comparisonData.style === 'pros_cons_comparison',
              'online-gambling-blue-header':
                comparisonData.style === 'general_comparison',
            }"
          >
            <p>
              <i v-if="!comparisonData.disabled_icon">
                <template v-if="comparisonData.left.icon">
                  <img
                    :src="comparisonData.left.icon"
                    width="26"
                    height="26"
                    alt="Tick Big"
                  />
                </template>
                <template v-else>
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.8644 2.43441C17.5097 0.245343 14.0078 0.639093 11.8464 3.07191L10.9999 4.02347L10.1535 3.07191C7.99643 0.639093 4.49018 0.245343 2.13549 2.43441C-0.562943 4.94691 -0.70474 9.45628 1.7101 12.1797L10.0246 21.5453C10.5617 22.15 11.4339 22.15 11.971 21.5453L20.2855 12.1797C22.7046 9.45628 22.5628 4.94691 19.8644 2.43441Z"
                      fill="white"
                    />
                  </svg>
                </template> </i
              >{{ comparisonData.left.heading }}
            </p>
          </div>
          <div class="online-gambling-green-content">
            <div
              :class="{
                'custom-font custm-text': true,
                'tick-div-green':
                  comparisonData.style === 'pros_cons_comparison' &&
                  comparisonData.left.content.indexOf('ul') > 0,
                'tick-div-blue':
                  comparisonData.style === 'general_comparison' &&
                  comparisonData.left.content.indexOf('ul') > 0,
                'num-cls':
                  comparisonData.style === 'general_comparison' &&
                  comparisonData.left.content.indexOf('ol') > 0,
              }"
              :style="{
                '--heading-font': $root.font_family.heading,
                '--paragraph-font': $root.font_family.paragraph,
              }"
              v-html="comparisonData.left.content"
            ></div>
          </div>
        </div>
        <div
          :class="{
            'online-gambling-red':
              comparisonData.style === 'pros_cons_comparison',
            'online-gambling-blue':
              comparisonData.style === 'general_comparison',
          }"
        >
          <div
            :class="{
              'online-gambling-red-header':
                comparisonData.style === 'pros_cons_comparison',
              'online-gambling-blue-header':
                comparisonData.style === 'general_comparison',
            }"
          >
            <p>
              <i v-if="!comparisonData.disabled_icon">
                <template v-if="comparisonData.right.icon">
                  <img
                    :src="comparisonData.right.icon"
                    width="26"
                    height="26"
                    alt="Cross Big"
                  />
                </template>
                <template v-else>
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.3541 1.95916L20.251 1.84197C18.2744 -0.361156 15.1806 -0.581468 12.9635 1.14822L14.4373 5.99509L10.3123 8.99509L12.3748 14.9951L6.18728 8.24509L10.3123 5.24509L9.08338 1.19041C6.86189 -0.581468 3.73807 -0.375218 1.74861 1.84666L1.64549 1.95916C-0.447091 4.29353 -0.537325 8.01072 1.33182 10.4998L10.4455 20.7467C10.7506 21.0888 11.2447 21.0888 11.5498 20.7467L20.6678 10.4951C22.5369 8.01072 22.4467 4.29353 20.3541 1.95916Z"
                      fill="white"
                    />
                  </svg>
                </template> </i
              >{{ comparisonData.right.heading }}
            </p>
          </div>
          <div class="online-gambling-red-content">
            <div
              :class="{
                'custom-font custm-text': true,
                'cross-div':
                  comparisonData.style === 'pros_cons_comparison' &&
                  comparisonData.right.content.indexOf('ul') > 0,
                'tick-div-blue':
                  comparisonData.style === 'general_comparison' &&
                  comparisonData.right.content.indexOf('ul') > 0,
                'num-cls':
                  comparisonData.style === 'general_comparison' &&
                  comparisonData.right.content.indexOf('ol') > 0,
              }"
              :style="{
                '--heading-font': $root.font_family.heading,
                '--paragraph-font': $root.font_family.paragraph,
              }"
              v-html="comparisonData.right.content"
            ></div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "ComparisonList",
  props: ["comparisonData", "comparisonAttrs", "page", "partnerProcons"],
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/base/variable";
.online-gambling {
  display: block;
  margin: 27px 0 37px;
  @media (min-width: @sizes[medium]) {
    .display-flex();
    .align-items(start);
    .justify-content-space-between();
  }
  &-half {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    margin-right: 0;
    margin-bottom: 15px;
    h6 {
      .display-flex();
      .align-items(center);
      border-bottom: 1px solid @border-gray;
      padding-bottom: 15px;
      margin-bottom: 0;
      i {
        margin-right: 10px;
        img {
          margin-bottom: 0;
        }
      }
    }
    ul {
      margin: 0;
      li {
        &:before {
          display: none;
        }
        padding: 17px 0;
        color: @lightdark;
        margin-bottom: 0;
      }
    }
    @media (min-width: @sizes[medium]) {
      margin-right: 42px;
      margin-bottom: 0;
    }
  }
  &-exclusive {
    .online-gambling-half {
      h6 {
        padding-left: 14px;
      }
      ul {
        li {
          padding-left: 44px;
        }
      }
      &.green {
        h6 {
          border-bottom: 2px solid @green;
        }
        ul {
          li {
            background: url(~@/assets/images/svg-icons/polygon-green.svg)
              no-repeat 14px 21px;
            background-size: 15px 15px;
          }
        }
      }
      &.orange {
        h6 {
          border-bottom: 2px solid @orange;
        }
        ul {
          li {
            background: url(~@/assets/images/svg-icons/polygon-orange.svg)
              no-repeat 14px 23px;
            background-size: 15px 15px;
          }
        }
      }
    }
  }
  &-container {
    .display-flex();
    .justify-content-space-between();
    margin: 0 -10px;
    @media (max-width: @sizes[tablet]) {
      flex-wrap: wrap;
    }
  }
  &-green {
    @media (min-width: @sizes[large]) {
      width: 610px;
    }
  }
  &-red {
    @media (min-width: @sizes[large]) {
      width: 610px;
      margin: 0 10px;
    }
  }
  &-blue {
    @media (min-width: @sizes[large]) {
      width: 610px;
    }
  }
}

.online-gambling-green {
  width: 100%;
  background: #e2f3e3;
  //border: 2px solid #40cf80;
  .border-radius(10px);
  margin: 0 10px;
  &-header {
    padding: 15px;
    background: #5abc5e;
    .border-radius(10px);
    margin: 10px 10px 0 10px;
    min-height: 50px;
    p {
      font-weight: bold;
      color: @white;
      margin-bottom: 0;
      position: relative;
    }
    i {
      width: 22px;
      height: 22px;
      position: relative;
      float: left;
      top: 0;
      right: 0;
      margin-right: 10px;
      img {
        margin-bottom: 0px !important;
      }
    }
  }
  &-content {
    padding: 18px 18px 0px 24px;
    ul {
      margin-bottom: 16px;
      li {
        position: relative;
        margin-bottom: 20px;
        font-weight: normal;
        font-size: 18px;
        line-height: 28px;
        //color: @blue;
        padding-left: 23px;
        &:last-child {
          margin-bottom: 0;
        }
        strong {
          font-weight: bold;
        }
        &:after {
          position: absolute;
          content: "";
          left: 0;
          top: 6px;
          //background: url(~@/assets/images/icons/tick-big.svg) no-repeat;
          width: 15px;
          height: 16px;
        }
      }
    }
  }
}
.online-gambling-red {
  width: 100%;
  background: #f9e6e6;
  //border: 2px solid #f64c4c;
  .border-radius(10px);
  margin: 0 10px;
  //border-color: @red;
  @media (max-width: @sizes[large]) {
    margin-top: 20px;
  }
  &-header {
    padding: 15px;
    background: #fe4646;
    .border-radius(10px);
    margin: 10px 10px 0 10px;
    min-height: 50px;
    p {
      font-weight: bold;
      color: @white;
      margin-bottom: 0;
      position: relative;
    }
    i {
      width: 26px;
      height: 26px;
      position: relative;
      top: 0;
      right: 0;
      float: left;
      margin-right: 10px;
      img {
        margin-bottom: 0px !important;
      }
    }
  }
  &-content {
    padding: 18px 18px 0px 24px;
    ul {
      margin-bottom: 16px;
      li {
        position: relative;
        margin-bottom: 20px;
        font-weight: normal;
        font-size: 18px;
        line-height: 28px;
        //color: @blue;
        padding-left: 23px;
        &:last-child {
          margin-bottom: 0;
        }
        strong {
          font-weight: bold;
        }
        &:after {
          position: absolute;
          content: "";
          left: 0;
          top: 6px;
          //background: url(~@/assets/images/icons/tick-big.svg) no-repeat;
          width: 15px;
          height: 16px;
        }
      }
    }
  }

  .online-gambling-red-header {
    background: #fe4646;
    i {
      padding: 0;
    }
  }
  .online-gambling-red-content {
    ul {
      li {
        &:after {
          //background: url(~@/assets/images/icons/cross2.svg) no-repeat;
        }
      }
    }
  }
}

.online-gambling-blue {
  width: 100%;
  background: #fff;
  //border: 2px solid #40cf80;
  .border-radius(10px);
  margin: 10px;
  @media (min-width: @sizes[extra-large]) {
    margin: 0 10px;
  }
  &-header {
    padding: 15px;
    background: #0084ff;
    .border-radius(10px);
    margin: 10px 10px 0 10px;
    min-height: 50px;
    p {
      font-size: 22px;
      font-weight: bold;
      color: @white;
      margin-bottom: 0;
      position: relative;
    }
    i {
      width: 26px;
      height: 26px;
      position: relative;
      float: left;
      top: 0;
      right: 0;
      margin-right: 10px;
      img {
        margin-bottom: 0px !important;
      }
    }
  }
  &-content {
    padding: 18px 18px 0px 24px;
    ul {
      margin-bottom: 16px;
      li {
        position: relative;
        margin-bottom: 20px;
        font-weight: normal;
        font-size: 18px;
        line-height: 28px;
        //color: @blue;
        padding-left: 23px;
        &:last-child {
          margin-bottom: 0;
        }
        strong {
          font-weight: bold;
        }
        &:after {
          position: absolute;
          content: "";
          left: 0;
          top: 6px;
          //background: url(~@/assets/images/icons/tick-big.svg) no-repeat;
          width: 15px;
          height: 16px;
        }
      }
    }
  }

  .online-gambling-blue-header {
    background: #0084ff;
    i {
      padding: 0;
    }
  }
  .online-gambling-blue-content {
    ul {
      li {
        &:after {
          //background: url(~@/assets/images/icons/cross2.svg) no-repeat;
        }
      }
    }
  }
}

.pros-li {
  padding-left: 37px !important;
  margin-bottom: 12px !important;
}

.cons-li {
  padding-left: 37px !important;
  margin-bottom: 12px !important;
}

.wd-50 {
  @media (min-width: @sizes[large]) {
    width: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/custom-block/ComparisonList.vue